jQuery(document).ready ($) ->
	$contactMap = $ '#contact-map'
	unless $contactMap.length > 0
		return


	map = new GMaps
		div: '#contact-map'
		lat: 55.756046
		lng: 37.6951899
		zoom: 14
		minZoom: 9
		maxZoom: 18
		panControl: false
		zoomControl: true
		zoomControlOpt:
			style: 'SMALL'
			position: 'TOP_RIGHT'
		streetViewControl: false
		mapTypeControl: false
		styles: [
			featureType: 'all'
			elementType: 'all'
			stylers: [
				saturation: -100
			,
				gamma: 0.5
			]
		]
		
	map.addMarker
		lat: 55.7453107
		lng: 37.7227452
		icon: '/wp-content/themes/oversun/images/map-marker.png'



/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/map.coffee
 **/